import {shareLink} from "./sharing";

export function shareItemcardModal(query = document.querySelectorAll('.js-openItemcardSharingModal')) {
    for (let link of query) {
        link.addEventListener("click", function () {
            if (navigator.canShare) {
                if (link.dataset.url && link.dataset.title) {
                    shareLink({
                        title: link.dataset.title,
                        url: link.dataset.url,
                    });
                }
            } else {
                console.warn("Sharing not possible with your browser");
            }
        });
    }
}